<template class="full-height">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="member-app-container" style="position: relative; height: 100%">
    <member-data />
  </div>
</template>

<script>
export default {
  name: 'MemberManagement',
  components: {
    memberData: () => import('@/views/ita/auth/member/components/memberList.vue'),
  },
  data() {
    return {
      list: null,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {},
    handleDownload() {},
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>
